import { Grid, Tab, Tabs } from '@mui/material';
import Box from '@mui/material/Box';
import { useState } from 'react';
import { DocumentHyperlink } from '../../components/DocumentHyperlink';
import { MainContainer } from '../../components/MainContainerComp';
import { DailyAllocations } from './DailyAllocations';
import { IVesselForecastData } from './VesselForecastData';
import { AllocationType } from './VesselForecastModels';
import { WeeklyAllocations } from './WeeklyAllocations';
import { containerStyle, tabStyle, tabsStyle, vancouerIslandLinkSectionStyle } from "./styled";


export const VesselForecast = ({
  data,
  weeklyAllocationsMainlandLink,
  weeklyAllocationsIslandLink,
  handleTabSelect,
  handleLocationSelect,
  handlePortSelect,
}: {
  data: IVesselForecastData,
  weeklyAllocationsMainlandLink: string,
  weeklyAllocationsIslandLink: string,
  handleTabSelect: (newValue: number) => void,
  handleLocationSelect: (allocationType: AllocationType, location: string) => void,
  handlePortSelect: (allocationType: AllocationType, location: string, port: string) => void,
}) => {
  const [tab, setTab] = useState(0);

  const selectTab = (_event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
    handleTabSelect(newValue);
  }

  return (
    <MainContainer hasGreyBg>
      <Grid container>
        <Grid item xs={12} sm={6} md={6}>
          <DocumentHyperlink
            link={weeklyAllocationsMainlandLink}
            title='L. Mainland, Squamish, and P.R. Weekly Alloc.'
            dataAutomation='weekly-alloc-mainland-link'
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <DocumentHyperlink
            link={weeklyAllocationsIslandLink}
            title='Vancouver Island Weekly Alloc.'
            dataAutomation='weekly-alloc-island-link'
            styles={vancouerIslandLinkSectionStyle}
          />
        </Grid>
      </Grid>
      <Tabs
        sx={tabsStyle}
        value={tab}
        onChange={selectTab}
      >
        <Tab
          disableRipple
          sx={tabStyle}
          label="Daily Allocations"
          data-automation="daily-alloc-tab"
        />
        <Tab
          disableRipple
          sx={tabStyle}
          label="Weekly Allocations"
          data-automation="weekly-alloc-tab"
        />
      </Tabs>
      <Box sx={containerStyle}>
        {tab === 0 && <DailyAllocations
          data={data.dailyAllocations}
          handleLocationSelect={handleLocationSelect}
          handlePortSelect={handlePortSelect}
        />}
        {tab === 1 && <WeeklyAllocations
          data={data.weeklyAllocations}
          handleLocationSelect={handleLocationSelect}
          handlePortSelect={handlePortSelect}
        />}
      </Box>
    </MainContainer>
  )
}